// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

import App from './App'
import router from './router'
import i18n from './lang/lang'
import moment from 'vue-moment'
import VueTruncate from 'vue-truncate-filter'
import FBSignInButton from 'vue-facebook-signin-button'
import VueCarousel from 'vue-carousel'
import VueRangedatePicker from 'vue-rangedate-picker'

import VeeValidate from 'vee-validate'

import VueClipboard from 'vue-clipboard2'
import Tooltip from 'vue-directive-tooltip'
import VueScrollTo from 'vue-scrollto'

import mainMixin from '@/mixins/mainMixin'
import errorMixin from '@/mixins/errorMixin'

import 'vue-directive-tooltip/css/index.css'
import 'vue-flash-message/dist/vue-flash-message.min.css'
import VueFlashMessage from 'vue-flash-message'
Vue.use(VueFlashMessage)

import './filters'

import FlagIcon from 'vue-flag-icon'

import { store } from './store/store'
import PremiumLock from '@/components/elements/PremiumLock'
import PremiumPlanPopup from '@/components/elements/PremiumPlanPopup'

import VueParticles from 'vue-particles'
import VueMaterial from 'vue-material'
import { SimpleSVG } from 'vue-simple-svg'
import MainLayout from '@/components/layouts/Main'
import PartnerLayout from '@/components/layouts/Partner'
import ModalHelp from '@/components/elements/ModalHelp2'
import Vuetify from 'vuetify'
import Vuebar from 'vuebar'
import VueSweetalert2 from 'vue-sweetalert2'

import VueTour from 'vue-tour'
import VueIntro from 'vue-introjs'
import 'intro.js/introjs.css'

import config from '@/config'

import th from 'vee-validate/dist/locale/th'
// import la from './lang/validate/la'

import 'vuetify/dist/vuetify.min.css'
import { Validator } from 'vee-validate'
import Paginate from 'vuejs-paginate'
import VueAnalytics from 'vue-analytics'

import LoadScript from 'vue-plugin-load-script'
import VueCountdown from '@chenfengyuan/vue-countdown'
import VueSanitize from 'vue-sanitize'
import NumericDirective from "./NumericDirective";

var defaultOptions = {
  allowedTags: ['a', 'br'],
  allowedAttributes: {
    a: ['href']
  }
}

Vue.use(VueSanitize, defaultOptions)
Vue.prototype.$aston = window.aston
Vue.component(VueCountdown.name, VueCountdown)
Vue.use(LoadScript)

Vue.use(VueAnalytics, {
  id: 'UA-52751393-10',
  router
})

Vue.component('paginate', Paginate)

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)
Vue.use(VueIntro)

const SweetalertoOptions = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, SweetalertoOptions)

Vue.use(Vuebar)
Vue.use(Vuetify, {
  theme: {
    primary: config.theme.brand_color
  }
})
Vue.use(VueParticles)

Vue.use(VueScrollTo)
Vue.use(Tooltip)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Validator.localize({ th: th })
// Validator.localize({ la: la })
Vue.use(VeeValidate, { locale: 'th', events: 'blur' })
Vue.use(VueCarousel)
Vue.use(FBSignInButton)
Vue.use(VueTruncate)
Vue.use(moment)
Vue.use(VueRangedatePicker)

Vue.use(FlagIcon)
Vue.use(VueMaterial)

Vue.component('main-layout', MainLayout)
Vue.component('partner-layout', PartnerLayout)
Vue.component('v-modal-help', ModalHelp)
Vue.component('v-premium-lock', PremiumLock)
Vue.component('v-premium-plan-popup', PremiumPlanPopup)

Vue.component('vue-simple-svg', SimpleSVG)

Vue.config.productionTip = false

// v-integer
// v-decimal
// v-decimal.unsigned
Vue.use(NumericDirective);
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Validator.extend(
  'isLessThanOrEqual',
  (value, [otherValue]) => {
    return parseFloat(value) <= parseFloat(otherValue)
  },
  {
    hasTarget: true
  }
)

Validator.extend('isUrl', value => {
  var pattern = new RegExp(
    /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  ) // fragment locator
  return pattern.test(value)
})
Validator.extend('excludednew', {
  validate: (value, [...otherValue]) => {
    var obj = value.replace(/,/g, '').replace(/[|]/g, '//#or//')
    return !otherValue.includes(obj)
  }
})
Validator.extend('isPhone', value => {
  var pattern = new RegExp(/^[+]?[0-9]{3,12}$/gim)
  return pattern.test(value)
})

Vue.mixin(mainMixin)
Vue.mixin(errorMixin)

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
})

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js